export default "__VITE_ASSET__IKN05Oo1__"